module.exports = new __parcel__URL__("hps_icon_small.4790ece6.png").toString();